module.exports = __webpack_public_path__ + "img/how_to_play_2021.20fe52f8.png";